import { Box } from "@mui/material";
import { Card } from "src/components/atoms/Card";
import { DashboardSummaryCard } from "../DashboardSummaryCard";
import { useBankruptcyCounts, useClassActionCounts } from "../../hooks";

export function DashboardClaimsAdminSummary() {
  const bankruptcyCounts = useBankruptcyCounts();
  const classActionCounts = useClassActionCounts();

  return (
    <Card title="Bankruptcies and Class Actions" sx={{ mb: 6 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 4,
        }}
      >
        <DashboardSummaryCard
          title="Bankruptcies"
          items={[
            {
              label: "Upcoming",
              value: bankruptcyCounts.upcoming,
              href: "/bankruptcy-events?view=upcoming",
              color: "#F57C00",
            },
            {
              label: "Active",
              value: bankruptcyCounts.active,
              href: "/bankruptcy-events?view=active",
              color: "#C62828",
            },
            {
              label: "Recently completed",
              value: bankruptcyCounts.recentlyCompleted,
              href: "/bankruptcy-events?view=recently-completed",
              color: "#388E3C",
            },
          ]}
        />
        <DashboardSummaryCard
          title="Class Actions"
          items={[
            {
              label: "Upcoming",
              value: classActionCounts.upcoming,
              href: "/class-action-events?view=upcoming",
              color: "#F57C00",
            },
            {
              label: "Active",
              value: classActionCounts.active,
              href: "/class-action-events?view=active",
              color: "#5D4037",
            },
            {
              label: "Recently completed",
              value: classActionCounts.recentlyCompleted,
              href: "/class-action-events?view=recently-completed",
              color: "#388E3C",
            },
          ]}
        />
      </Box>
    </Card>
  );
}
